/**
 * 枚举选项通用对象
 */
export class Item {
  /**
   *
   * @param key {string} 后台接口需要的值
   * @param comment {string} 前端显示值
   * @param deprecated {boolean} 是否废弃
   * @param checked {boolean} 默认是否选中
   */
  constructor(key, comment,comment1, {deprecated = false, checked = false} = {}) {
    /**
     * 后台接口需要的值
     * @type {string}
     */
    this.key = key
    /**
     * 前端显示值
     * @type {string}
     */
    this.comment = comment
    /**
     * 是否废弃
     * @type {boolean}
     */
    this.deprecated = deprecated
    /**
     * 默认是否选中
     * @type {boolean}
     */
    this.checked = checked
    this.comment1=comment1
  }
}


export const RoleEnums = {
  ROLE_PILOT: new Item('ROLE_PILOT', 'PILOT 飞行员','飞行员'),
  ROLE_ATT: new Item('ROLE_ATT', 'ATT 乘务员','乘务员'),
  ROLE_SC: new Item('ROLE_SC', 'SC 安全员','安全员(空警)'),
  ROLE_SCDR: new Item('ROLE_SCDR', 'SC 地面值班室','空警地面值班室'),
  ROLE_SOC: new Item('ROLE_SOC', 'SOC','SOC'),
  /**
   * 这里是为了 @type 自动生成选项
   * @return {Item[]}
   */
  options: () => Object.keys(RoleEnums)
    .filter(key => key !== 'options')
    .map(key => {
      const {comment,comment1, deprecated, checked} = RoleEnums[key]
      return new Item(key, comment,comment1, {deprecated, checked})
    })
}



// WEBPACK FOOTER //
// ./src/api/Enums.js